var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_1730)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5.90746,
    fill: "url(#paint0_linear_628_1730)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.657715,
    y: 0.657471,
    width: 22.6849,
    height: 22.6849,
    rx: 5.58376,
    fill: "url(#paint1_linear_628_1730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8598 6.64185C10.8238 6.64185 9.81103 6.94906 8.94961 7.52465C8.08819 8.10023 7.41679 8.91833 7.02032 9.87549C6.62385 10.8326 6.52012 11.8859 6.72224 12.902C6.92435 13.9181 7.42325 14.8515 8.15582 15.5841C8.8884 16.3166 9.82176 16.8155 10.8379 17.0176C11.854 17.2198 12.9072 17.116 13.8644 16.7196C14.8215 16.3231 15.6396 15.6517 16.2152 14.7903C16.7908 13.9288 17.098 12.9161 17.098 11.8801C17.0966 10.4913 16.5442 9.15974 15.5622 8.17771C14.5801 7.19567 13.2486 6.64331 11.8598 6.64185ZM13.4716 13.2904C13.4716 13.3438 13.4503 13.395 13.4126 13.4328C13.3748 13.4706 13.3235 13.4918 13.2701 13.4918H10.4495C10.3961 13.4918 10.3448 13.4706 10.3071 13.4328C10.2693 13.395 10.248 13.3438 10.248 13.2904V10.4698C10.248 10.4163 10.2693 10.3651 10.3071 10.3273C10.3448 10.2895 10.3961 10.2683 10.4495 10.2683H13.2701C13.3235 10.2683 13.3748 10.2895 13.4126 10.3273C13.4503 10.3651 13.4716 10.4163 13.4716 10.4698V13.2904Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_1730",
    x1: -6.90411,
    y1: -2.13699,
    x2: 24.8219,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_1730",
    x1: 6.5907,
    y1: 2.75146,
    x2: 23.3426,
    y2: 30.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5.90746,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopped);
export default __webpack_public_path__ + "static/media/stopped.234553f5117f4e210b5f260244599b6c.svg";
export { ForwardRef as ReactComponent };